import { useCallback, useEffect, useState } from "react";
import { TypeParams } from "../../../types";
import { makeApiRequest } from "../../../lib/api";
import { Alert, Spin } from "antd";
import { useTranslation } from "react-i18next";

interface EgwClientareaSurveysProps {
  // commitCurrentPlace: (placeId: number | null) => void;
  params: TypeParams; // Define the type of the ccid prop
}

const EgwClientareaSurveys: React.FC<EgwClientareaSurveysProps> = ({ params }) => {
  const [surveys, setSurveys] = useState<null | any[]>(null);
  const { t } = useTranslation(); // Initialize the translation hook
  const [error, setError] = useState("");

  const composeSurveyUrl = useCallback(
    (survey: any): string => {
      let url = "";
      if (survey.language) {
        url += `/${survey.language}`;
      }
      url += `?page=kundenbereich&section=form&backend=${params.backend}`;
      url += `&iid=${survey.info_id}&cid=${survey.contact_id}`;
      url += `&ct=${survey.ct}`; // CpapTherapy
      url += `&od=${survey.od}`; // OsasDisease
      url += `&po=${survey.po}`;
      url += `&pi=${survey.pi}`;
      url += `&ccid=${params.ccid}`;

      if (survey.info_cat_name === "postsurvey") {
        url += `&s=PS`;
      }
      if (survey.info_cat_name === "anamnese") {
        url += `&s=CA`;
      }
      return url;
    },
    [params]
  );

  const onLoadForm1 = useCallback(async () => {
    setError("");
    try {
      let action = "";
      let content: any = {};
      action = "REACT_SURVEY_LIST";
      content = {};
      const response = (await makeApiRequest(params, action, content)) as any;
      const parsed = JSON.parse(response);
      if (!parsed || parsed.STATUS !== "OK") {
        setError(t("survey.list.error"));
      } else {
        if (parsed.MESSAGE !== "OK") {
          setError(t("survey.list.loadError"));
        } else {
          setSurveys(parsed.CONTENT);
        }
      }
    } catch (error) {
      setError(t("survey.list.error"));
    }
  }, [params, t]);

  // INIT
  useEffect(() => {
    onLoadForm1();
  }, [onLoadForm1]);

  useEffect(() => {
    // if only one survey is found directly redirect to it:
    if (surveys && surveys.length === 1) {
      const survey = surveys[0];
      const url = composeSurveyUrl(survey);
      window.location.href = url;
    }
  }, [composeSurveyUrl, surveys]);

  if (error) {
    return (
      <>
        <Alert message={error} type="error" showIcon />
      </>
    );
  }

  if (surveys === null) {
    return <Spin size="large" />;
  }

  if (surveys.length === 0) {
    return <Alert message={t("survey.list.noSurveys")} type="info" showIcon />;
  }

  return (
    <>
      <h4>{t("survey.list.selectSurvey")}</h4>
      <br />
      {surveys.map((survey) => (
        <div key={survey.info_id}>
          <li>
            <strong>{t(`survey.${survey.info_cat_name}.title`)}</strong>:&nbsp;<a href={composeSurveyUrl(survey)}>Fragebogen Starten</a>
          </li>
        </div>
      ))}
    </>
  );
};

export default EgwClientareaSurveys;
